import { globalPut } from "../index";

// PUT /brands/:id/disabled — halt (disabled:true) or resume (disabled:false) a
// brand. When halted, the worker stops ALL processing for it (schedulers,
// queues, AI generation, posting) and the app blocks its flows until resumed.
export const setBrandDisabled = (id, disabled) =>
  globalPut(`/brands/${id}/disabled`, { disabled }, false);
